import { call, put, takeEvery, select } from "redux-saga/effects"

import { GET_CUSTOM_LIST_BY_TYPE, CREATE_CUSTOM_LIST, PATCH_CUSTOM_LIST } from "./constants"

import {
  manageErrorGenerator,
  manageSuccessGenerator,
  responseTypeIsSuccess,
  responseTypeIsError,
} from "Containers/App/saga"

// Actions
import { getCustomListByTypeAction, getCustomListByTypeSuccessAction } from "./actions"
import { setErrorMessage } from "Containers/Messages/actions"

// Utils
import { postCors, patchCors, getCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"

// Selectors
import { selectCurrentToken, selectLangageID } from "Containers/Login/selectors"

function* getCustomListByTypeSaga({ payload }) {
  const { listType } = payload
  const token = yield select(selectCurrentToken)
  const myLanguageId = yield select(selectLangageID)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const languageIdQuery = `languageId=${myLanguageId}`
  const requestURL = `${FORM_BACK_URL}/customList/${listType}?${languageIdQuery}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        // Actuellement on triche, car la route get toutes les listes DE CE TYPE, mais pour l'instant
        // comme en front on a pas de possibilité de sélectionner une liste, on prend la première liste renvoyée du back. d'ou le body[0]
        const customList = response?.body[0]
        yield put(getCustomListByTypeSuccessAction({ listType, customList }))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      }
    }
  } catch (err) {
    console.error("[route] => /customList/:listType => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* createCustomListSaga({ payload }) {
  const { customList } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customList`

  try {
    const response = yield call(request, requestURL, postCors({ customList }, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getCustomListByTypeAction({ listType: customList?.type }))
      }
    }
  } catch (err) {
    console.error("[route] => /customList/:listType => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* patchCustomListSaga({ payload }) {
  const { customList } = payload
  const listType = customList?.type
  const listId = customList?._id?.$oid
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customList/${listType}/${listId}`

  try {
    const response = yield call(request, requestURL, patchCors({ customList }, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getCustomListByTypeAction({ listType }))
      }
    }
  } catch (err) {
    console.error("[route] => /customList/:listType => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

export default function* customListsSaga() {
  yield takeEvery(GET_CUSTOM_LIST_BY_TYPE, getCustomListByTypeSaga)
  yield takeEvery(CREATE_CUSTOM_LIST, createCustomListSaga)
  yield takeEvery(PATCH_CUSTOM_LIST, patchCustomListSaga)
}
